(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-premium"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript ? document.currentScript.closest('.mlx-pdp') : document.querySelector('.mlx-pdp');
  if(!root) root = document.querySelector('.mlx-pdp');
  if(!root) return;
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch(e){}
  var idInput = root.querySelector('[data-variant-id]');
  var addBtn  = root.querySelector('[data-add]');
  var addText = root.querySelector('[data-add-text]');
  var priceEl = root.querySelector('[data-price]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  function money(cents){
    try { return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(cents/100); }
    catch(e){ return '₹'+(cents/100); }
  }
  function selected(){
    var groups = root.querySelectorAll('.mlx-chips');
    var opts = [];
    groups.forEach(function(g){
      var p = g.getAttribute('data-option-position');
      var active = g.querySelector('.mlx-chip[aria-pressed="true"]');
      opts[p-1] = active ? active.getAttribute('data-value') : null;
    });
    return opts;
  }
  function match(){
    var opts = selected();
    if(opts.indexOf(null) > -1 && opts.length) return null;
    return variants.find(function(v){
      return (v.options||[]).every(function(o,i){ return o === opts[i]; });
    });
  }
  function update(){
    var v = match();
    if(!v){
      if(addText) addText.textContent = 'Choose options';
      if(addBtn) addBtn.disabled = true;
      return;
    }
    if(idInput) idInput.value = v.id;
    if(priceEl) priceEl.textContent = money(v.price);
    if(stickyPrice) stickyPrice.textContent = money(v.price);
    if(v.available){
      if(addBtn) addBtn.disabled = false;
      if(addText) addText.textContent = 'Add to bag — ' + money(v.price);
    } else {
      if(addBtn) addBtn.disabled = true;
      if(addText) addText.textContent = 'Sold out';
    }
  }
  root.querySelectorAll('.mlx-chips').forEach(function(g){
    g.addEventListener('click', function(e){
      var b = e.target.closest('.mlx-chip'); if(!b) return;
      g.querySelectorAll('.mlx-chip').forEach(function(c){ c.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      update();
    });
  });
  var stage = root.querySelector('[data-stage]');
  var navs = root.querySelectorAll('.mlx-thumb, .mlx-dot');
  if(stage && navs.length){
    navs.forEach(function(t){
      t.addEventListener('click', function(){
        var i = parseInt(t.getAttribute('data-go'),10) || 0;
        var slide = stage.querySelector('[data-slide="'+i+'"]');
        if(slide) stage.scrollTo({left: slide.offsetLeft, behavior:'smooth'});
      });
    });
    var sync = function(){
      var i = Math.round(stage.scrollLeft / stage.clientWidth);
      navs.forEach(function(t){ t.classList.toggle('is-active', parseInt(t.getAttribute('data-go'),10) === i); });
    };
    stage.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, {passive:true});
  }
  root.querySelectorAll('[data-scroll-buy]').forEach(function(b){
    b.addEventListener('click', function(){
      var buy = root.querySelector('.mlx-buy');
      if(buy) buy.scrollIntoView({behavior:'smooth'});
    });
  });
  var modal = root.querySelector('[data-modal]');
  function showPanel(which){
    root.querySelectorAll('.mlx-panel').forEach(function(p){
      p.hidden = (p.getAttribute('data-panel') !== which);
    });
  }
  function openModal(which){ if(!modal) return; showPanel(which); modal.hidden = false; document.body.style.overflow='hidden'; }
  function closeModal(){ if(!modal) return; modal.hidden = true; document.body.style.overflow=''; }
  root.querySelectorAll('[data-open]').forEach(function(b){
    b.addEventListener('click', function(){ openModal(b.getAttribute('data-open')); });
  });
  if(modal){
    modal.querySelectorAll('[data-close]').forEach(function(c){ c.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeModal(); });
  }
  var mmInput = root.querySelector('[data-fit-mm]');
  var fitOut = root.querySelector('[data-fit-out]');
  var fitSizeEl = root.querySelector('[data-fit-size]');
  var fitApply = root.querySelector('[data-fit-apply]');
  var recommended = null;
  function recommend(){
    var v = parseFloat(mmInput.value);
    if(isNaN(v)){ if(fitOut) fitOut.hidden = true; return; }
    if(v <= 11) recommended = 'XS';
    else if(v <= 12) recommended = 'S';
    else if(v <= 13) recommended = 'M';
    else recommended = 'L';
    if(fitSizeEl) fitSizeEl.textContent = recommended;
    if(fitOut) fitOut.hidden = false;
  }
  if(mmInput) mmInput.addEventListener('input', recommend);
  if(fitApply) fitApply.addEventListener('click', function(){
    if(!recommended) return;
    var chip = Array.prototype.find.call(root.querySelectorAll('.mlx-chip'), function(c){
      return (c.getAttribute('data-value')||'').toUpperCase() === recommended;
    });
    if(chip){ chip.click(); closeModal(); }
  });
  var sticky = root.querySelector('[data-sticky]');
  var buy = root.querySelector('.mlx-buy');
  if(sticky && buy && 'IntersectionObserver' in window){
    new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(window.innerWidth > 860){ sticky.classList.remove('is-show'); return; }
        sticky.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    },{threshold:0}).observe(buy);
  }
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
